import React from 'react';
import { useAtom } from 'jotai';
import { Header } from 'Components/Common';
import {
  ticketAtom,
} from 'Atoms/Ticket';
import { staticDataAtom } from 'Atoms/Common';
import { formattingDigitCurrency, getTicketAliasFromPathname, CallApi } from 'utils';
import {
  useParams,
  useHistory
} from "react-router-dom";
import { Grid,makeStyles, Typography, InputBase } from '@material-ui/core';
const { REACT_APP_TOKEN_API } = process.env;

function blobToBase64(blob) {
  return new Promise((resolve, _) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
}

const useStyles = makeStyles((theme) => ({
  total: {
    marginTop: "30px"
  },
  ErrorContainer: {
    marginTop: "30px",
    marginRight: "10px",
    textAlign: "right"
  },
  Title: {
    opacity: 1,
    color: "rgba(38,41,87,1)",
    fontFamily: "FuturaStdBold",
    fontSize: "30px",
    fontWeight: 700,
    fontStyle: "normal",
    letterSpacing: "0px",
    textAlign: "center",
    lineHeight: "36px",
    marginBottom: "50px",
    marginLeft: "17px",
    '& span:nth-child(1)': {
      backgroundImage: "linear-gradient(90deg, #262957, #5AC8F5)",
      "-webkit-background-clip": "text",
      '-webkit-text-fill-color': "transparent",
      "-moz-background-clip": "text",
      "-moz-text-fill-color": "transparent",
      }
  },
  Error: {
    opacity: 1,
    color: "RGB(38, 41, 87)",
    fontFamily: ['Nunito Sans', 'sans-serif'].join(','),
    fontSize: "22px",
    fontWeight: 700,
    fontStyle: "normal",
    textAlign: "right",
    "& span": {
      color: "rgba(171,34,33,1)",
    }
  },
  Title2: {
    marginLeft: "17px",
    color: "#262957",
  },
  CardContainer: {
    backgroundImage: `url(${process.env.PUBLIC_URL}/icon/check-card.png)`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "auto",
    backgroundPositionX: "245px",
    paddingTop: "50px",
    marginTop: "-40px",
  },
  CardContainerError: {
    backgroundImage: `url(${process.env.PUBLIC_URL}/icon/error-card.png)`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "auto",
    backgroundPositionX: "245px",
    paddingTop: "50px",
    marginTop: "-40px",
  },
  CardContainerValid: {
    backgroundImage: `url(${process.env.PUBLIC_URL}/icon/valid-card.png)`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "auto",
    backgroundPositionX: "255px",
    paddingTop: "50px",
    marginTop: "-40px",
  },
  Card: {
    backgroundImage: `url(${process.env.PUBLIC_URL}/icon/card.png)`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    filter: "drop-shadow(0px 6px 20px rgb(0 0 0 / 20%))",
    height: "366px",
    width: "366px"
  },
  CardNumber: {
    position: "relative",
    top: "235px",
    display: "inline",
    "& span:nth-child(1)": {
      color: "#fff",
      marginLeft: "-10px",
      fontFamily: ['Nunito Sans', 'sans-serif'].join(','),
      fontWeight: "800",
      fontSize: "30px",
      verticalAlign: "middle"
    }
  },
  CardImputNumber: {
    backgroundColor: "#fff",
    width: "34px",
    height: "46px",
    marginLeft: "5px",
    borderRadius: "7px",
    fontFamily: ['Nunito Sans', 'sans-serif'].join(','),
    fontWeight: 800,
    fontSize: "30px",
    verticalAlign: "middle",
    '& input': {
      padding: "1px 2px",
      textAlign: "center",
      fontFamily: ['Nunito Sans', 'sans-serif'].join(','),
      fontWeight: 700,
      "-moz-appearance":"textfield",
      '&::-webkit-inner-spin-button': {
        "-webkit-appearance": "none",
        margin: 0,
      },
      '&:focus': {
        borderRadius: "7px",
        border: "4px solid rgba(90,200,245, 1)",
        opacity: 1,
      }
    }
  }
}));

const TicketCBAvailable = () => {
  const classes = useStyles();
  const [ticket] = useAtom(ticketAtom);
  const history = useHistory();
  const { idPayment } = useParams();
  const [staticData, setStaticData] = useAtom(staticDataAtom);
  const [pdfTicket, setpdfTicket] = React.useState("");
  const [firstInput, setFirstInput] = React.useState("");
  const [secondInput, setSecondInput] = React.useState("");
  const firstInputRef = React.useRef();
  const secondInputRef = React.useRef();
  const [cardNumberValid, setCardNumberValid] = React.useState("pending")

  /*React.useEffect(() => {
    async function getTicket() {
      if (ticket.order.ticketAvailableToPrint) {
        const pathname = window?.location?.pathname;
        const ticketAlias = getTicketAliasFromPathname(pathname);

        let header = {
          Authorization: [REACT_APP_TOKEN_API],
          ticketAlias: ticketAlias,
        };
        if(type == "paymentLine") {
          header["paymentId"] = idPayment
        }
        const result = await CallApi("get", "ticket/demand", "", "", header);
        setUrlTicket(result[0].urlFormated)
      }
    }
    getTicket();
  }, [])*/
  console.log(ticket)
  console.log(idPayment)

  const currency = staticData?.currency;
  const amountFormatting = (amount) => {
    return formattingDigitCurrency(
      amount,
      currency?.countryCode,
      currency?.labelCode,
    );
  };

  function handleFirstInput(e) {
    e.preventDefault();
    const value = e.target.value;
    if (!isNaN(value) && value < 10 && value.length <= 1) {
      setFirstInput(value);
      if (value != "") {
        secondInputRef.current.focus();
      }
      if(secondInput) {
        checkCardNumber(e.target.value, secondInput);
      }
    }
  }

  function handleSecondInput(e) {
    e.preventDefault();
    const value = e.target.value;
    if (!isNaN(value) && value < 10 && value.length <= 1) {
      setSecondInput(e.target.value);
    }
    if (value != "" && !firstInput) {
      firstInputRef.current.focus();
    }
    if(firstInput) {
      checkCardNumber(firstInput, e.target.value);
    }
  }

  async function checkCardNumber(first, second) {
    const pathname = window?.location?.pathname;
    const ticketAlias = getTicketAliasFromPathname(pathname);
    let header = {
      Authorization: [REACT_APP_TOKEN_API],
      ticketAlias: ticketAlias,
      paymentId: idPayment,
    };
    const data = await CallApi("get", "cb/ticket/pan-check", "", "", {...header, "x-pan": `${first}${second}`});
    if (data[0].ok) {
      setCardNumberValid("ok");

      try {

        const result = await CallApi("get", "cb/ticket/demand", "", "", header, {responseType: 'blob',});
        console.log(result[0])
        const urlPdf = window.URL.createObjectURL(result[0])
        //window.open(urlPdf);
        setpdfTicket(urlPdf)
      } catch(err) {
        setpdfTicket("error")
      }
    } else {
      setFirstInput("");
      setSecondInput("");
      firstInputRef.current.focus()
      setCardNumberValid("error");
    }
  }

  const payment = ticket?.order?.payments?.done?.items.find(item => item.id == idPayment);

  if (!payment && ticket?.order?.payments?.done?.items.length) {
    const pathname = window?.location?.pathname;
    const ticketAlias = getTicketAliasFromPathname(pathname);
    history.push(`/ticket/:${ticketAlias}`)
  }

  //const cardContainerClasse = cardNumberValid == "pending" || cardNumberValid == "ok" ? classes.CardContainer : classes.CardContainerError
  let cardContainerClasse = classes.CardContainer
  if (cardNumberValid == "ok") {
    cardContainerClasse = classes.CardContainerValid
  }
  if (cardNumberValid == "error") {
    cardContainerClasse = classes.CardContainerError
  }
  return payment ? (
    <>
    <Header
        actions={{
          prev: {
            label: `${payment.method} (${amountFormatting(payment.amount)})`,
            path: `/ticket/:${ticket.id}/requestTicket/${idPayment}`,
            icon: 'return',
          },
        }}
      ></Header>
        <>
          <Grid item xs={12} className={classes.total}>
            <Typography display="inline" className={classes.Title}>
              <span>La sécurité avant</span><br/><span className={classes.Title2}>tout !</span>
            </Typography>
          </Grid>
          <Grid item xs={12} className={cardContainerClasse}>
            <div className={classes.Card}>
              <div className={classes.CardNumber}>
                <div>
                  <span>X XXXX XX</span>
                  <InputBase
                    className={classes.CardImputNumber}
                    type={"number"}
                    inputProps={
                      {
                        min:"0",
                        max:"9",
                        pattern:"[0-9]*"
                      }
                    }
                    onInput={handleFirstInput}
                    inputRef={firstInputRef}
                    value={firstInput}
                  />
                  <InputBase
                    className={classes.CardImputNumber}
                    type={"number"}
                    inputProps={
                      {
                        min:"0",
                        max:"9",
                        pattern:"[0-9]*"
                      }
                    }
                    inputRef={secondInputRef}
                    onInput={handleSecondInput}
                    value={secondInput}
                  />
                </div>
              </div>
            </div>
          </Grid>
          {cardNumberValid == "error" ? (
            <Grid item xs={12} className={classes.ErrorContainer}>
              <Typography display="inline" className={classes.Error}>
                <span>Attention</span>, un ou plusieurs chiffres sont <span>incorrects</span>. Veuillez réessayer.
              </Typography>
            </Grid>
          ) : cardNumberValid == "pending" ? (<Grid item xs={12} className={classes.ErrorContainer}>
            <Typography display="inline" className={classes.Error}>
            Veuillez saisir les deux derniers chiffres de votre carte pour consulter votre ticket.
            </Typography>
          </Grid>) : null}
        {pdfTicket && pdfTicket !== "error" ? (
          <Grid item xs={12} style={{textAlign: "center", marginTop: "20px"}}>
          <a style={{
            color: "rgba(255,255,255,1)",
            fontFamily: "FuturaStdBold",
            fontSize: "22px",
            fontWeight: 900,
            fontStyle: "normal",
            letterSpacing: "0px",
            textAlign: "left",
            borderRadius: "30px",
            backgroundColor: "rgba(232,66,73, 1)",
            padding: "15px",
          }} href={pdfTicket} target="_blank">Voir le ticket</a>
          </Grid>
        ) : null}
        {pdfTicket === "error" ? (
          <Grid item xs={12} className={classes.ErrorContainer}>
          <Typography display="inline" className={classes.Error}>
            Le ticket n'est pas encore <span>disponible</span>, veuillez réessayer plus tard.
          </Typography>
        </Grid>
        ) : null}
      </>


    </>
  ) : null;
};

export default TicketCBAvailable;
